import {
  I_ACCESS_TOKEN_PARAMS,
  I_COMMON_DELETE_PARAMS,
  I_COMMON_GET_ITEM_PARAMS,
  I_COMMON_CREATE_PARAMS,
  I_COMMON_PUT_PARAMS,
  I_COMMON_IMPORT_PARAMS,
  _customFetch,
  getFetchGETOptions,
  getFetchDELETEOptions,
} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- COLLABORATEURS
// ---------------------------------

const ENDPOINT_COLLABORATORS = '/collaborators';

const logger = LoggerService.getInstance();


interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  functions: string;
  directions: string;
  hubs: string;
  sites: string;
  skills: string;
}
interface I_COLLABORATOR_FIELDS {
  /** email du collaborateur */
  email: string;
  /** nom du collaborateur */
  lastname: string;
  /** prénom du collaborateur */
  firstname: string;
  /** Matricule du collaborateur */
  id_osac: string;
  /** Site OSAC du collaborateur */
  office_site: string;
  /** Direction du collaborateur */
  direction: string;
  /** Pôle de direction du collaborateur (optionnel, les directeurs n'en ont pas) */
  hub?: string;
  /** Fonction/Poste du collaborateur */
  func: string; // NB : function est un mot clé
  /** Volume horaire du collaborateur */
  hourly_volume: number;
  /** true si le collaborateur ne peut pas être attribué à une activité */
  non_attribuable: boolean;
  /** Compétences du collaborateur */
  skills: number[],
}
interface I_COLLABORATOR_POST_PARAMS extends I_COMMON_CREATE_PARAMS, I_COLLABORATOR_FIELDS {}
interface I_COLLABORATOR_PUT_PARAMS extends I_COMMON_PUT_PARAMS, I_COLLABORATOR_FIELDS {}


/**
 * Requete le endpoint collaborators
 * Récupère la liste des collaborateurs
 * @param param0
 */
const get = async ({accessToken,page,functions,directions,hubs,sites,skills}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramFunctions = `functions=${functions}`;
  const paramDirections = `directions=${directions}`;
  const paramHubs = `hubs=${hubs}`;
  const paramSites = `sites=${sites}`;
  const paramSkills = `skills=${skills}`;
  const paramsAll = [paramFunctions,paramDirections,paramHubs,paramSites,paramSkills].join('&');
  const URL = `${ENDPOINT_COLLABORATORS}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}${paramPage}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint collaborator
 * Récupère le collaborator
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_COLLABORATORS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint collaborator POST
 * Ajoute un collaborateur
 * @param param0
 * @returns
 */
export const post = async (args:I_COLLABORATOR_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - post...'));
  const {
    accessToken,
    email,firstname,lastname,
    id_osac, office_site, direction, hub, func, hourly_volume, non_attribuable, skills,
  } = args;
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      email: encodeURIComponent(email.trim()),
      firstname: encodeURIComponent(firstname.trim()),
      lastname: encodeURIComponent(lastname.trim()),
      id_osac: encodeURIComponent(id_osac.trim()),
      office_site: encodeURIComponent(office_site),
      direction: encodeURIComponent(direction),
      hub: encodeURIComponent(hub || ''),
      function: encodeURIComponent(func),
      hourly_volume: encodeURIComponent(hourly_volume),
      non_attribuable,
      skills,
    })
  };
  const URL = ENDPOINT_COLLABORATORS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint collaborator DELETE
 * Supprime un collaborateur
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_COLLABORATORS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

/**
 * Requete le endpoint collaborator PUT
 * Met à jour un collaborateur
 * @param param0
 * @returns
 */
const put = async (args:I_COLLABORATOR_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - put...'));
  const {
    accessToken,id,
    email,firstname,lastname,
    id_osac, office_site, direction, hub, func, hourly_volume, non_attribuable, skills,
  } = args;
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      email: encodeURIComponent(email.trim()),
      firstname: encodeURIComponent(firstname.trim()),
      lastname: encodeURIComponent(lastname.trim()),
      id_osac: encodeURIComponent(id_osac.trim()),
      office_site: encodeURIComponent(office_site),
      direction: encodeURIComponent(direction),
      hub: encodeURIComponent(hub || ''),
      function: encodeURIComponent(func),
      hourly_volume: encodeURIComponent(hourly_volume),
      non_attribuable,
      skills,
    })
  };
  const URL = `${ENDPOINT_COLLABORATORS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};



/**
 * Requete le endpoint activity-types POST file
 * Importe des collaborateurs
 * @param param0
 * @returns
 */
const importList = async ({accessToken,file}:I_COMMON_IMPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - collaborators - importList...'));
  const formData  = new FormData();
  formData.append("file",file,file.name);
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      // 'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: formData,
  };
  const URL = `${ENDPOINT_COLLABORATORS}/import${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const collaboratorsEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
  importList,
};

export default collaboratorsEndpoints;
